import
  React
from 'react';

export default () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7882 5.0542L6.24242 11.6L3.33325 8.69086" stroke="#428600" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);